<label class="overhead">If secured asset is not available, please select the appropriate TBA year e.g 2024 TBA. If the Variant is not available select My caravan is not on the list. Please provide details in your submission notes.</label>
<mat-form-field appearance="outline" [formGroup]="formGroup">
  <mat-label>{{placeholderText}}</mat-label>
  <input matInput placeholder="{{placeholderText}}" [matAutocomplete]="auto" formControlName="text">
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="updatedSelectedVehicleRecord($event.option.value)" panelWidth="panelWidth">
    <mat-option *ngFor="let car of filteredCars" [value]="car.description" >
      <span>{{ car.description }}</span>
    </mat-option>
  </mat-autocomplete>
  <mat-error>{{ errorMessage || 'Please search and select a valid secured asset' }}</mat-error>
</mat-form-field>
